// MACHINE DRAFT — clinical and native-speaker review required.
export default {
  "fr": [
    "Questions sur ma préparation",
    "Sélectionnez les questions dont vous souhaitez discuter avec l’équipe de votre hôpital.",
    "Sélectionner cette question",
    "Enregistrer les questions sélectionnées dans Mes soins",
    "Imprimer les questions sélectionnées",
    "Déjà enregistré dans Mes soins",
    "Les questions sélectionnées ont été enregistrées dans Mes soins sur cet appareil.",
    "Sélectionnez une ou plusieurs questions à enregistrer ou à imprimer.",
    "Questions que je souhaite poser",
    "Voici les questions sur votre préparation que vous avez sélectionnées. Vous pouvez les enregistrer dans Mes soins ou les imprimer pour votre rendez-vous.",
    "Ouvrir Mes soins",
    "Imprimer ces questions ne les envoie pas à l’hôpital.",
    "Ces questions ne remplacent pas les instructions de votre hôpital. Pour les médicaments, le jeûne préopératoire et l’organisation de votre sortie, suivez les consignes personnalisées données par votre équipe hospitalière.",
    "Quand dois-je arrêter de manger et de boire avant mon opération ?",
    "Lesquels de mes médicaments habituels dois-je prendre ou modifier avant mon opération ?",
    "Où dois-je me rendre et à quelle heure dois-je arriver ?",
    "Où dois-je me présenter et à quelle heure pour mon hospitalisation ?",
    "Dois-je organiser mon transport jusqu’à l’hôpital ou demander si je peux bénéficier d’un transport sanitaire pour patients ?",
    "Aurai-je besoin que quelqu’un me raccompagne chez moi ou reste avec moi après l’opération ?",
    "De quelle aide pourrais-je avoir besoin à ma sortie de l’hôpital et à qui dois-je en parler ?",
    "Qui dois-je contacter si j’ai des inquiétudes après mon retour à domicile ?"
  ],
  "gu": [
    "મારી તૈયારી વિશેના પ્રશ્નો",
    "તમારી હોસ્પિટલની સંભાળ ટીમ સાથે જે બાબતો વિશે વાત કરવા માંગો છો તે પસંદ કરો.",
    "આ પ્રશ્ન પસંદ કરો",
    "પસંદ કરેલા પ્રશ્નો ‘મારી સંભાળ’માં સાચવો",
    "પસંદ કરેલા પ્રશ્નો છાપો",
    "પહેલેથી ‘મારી સંભાળ’માં સાચવેલું છે",
    "પસંદ કરેલા પ્રશ્નો આ ઉપકરણ પર ‘મારી સંભાળ’માં સાચવવામાં આવ્યા છે.",
    "સાચવવા અથવા છાપવા માટે એક કે વધુ પ્રશ્નો પસંદ કરો.",
    "હું પૂછવા માંગું છું તે પ્રશ્નો",
    "આ તમે તમારી તૈયારી વિશે પસંદ કરેલા પ્રશ્નો છે. તમે તેને ‘મારી સંભાળ’માં સાચવી શકો છો અથવા તમારી મુલાકાત માટે છાપી શકો છો.",
    "‘મારી સંભાળ’ ખોલો",
    "પ્રશ્નો છાપવાથી તે હોસ્પિટલને મોકલાતા નથી.",
    "આ પ્રશ્નો તમારી હોસ્પિટલની સૂચનાઓના સ્થાને નથી. દવાઓ, ઓપરેશન પહેલાં ખાવા-પીવાનું બંધ રાખવા અને હોસ્પિટલમાંથી રજા મેળવવાની વ્યવસ્થા માટે તમારી હોસ્પિટલની સંભાળ ટીમની વ્યક્તિગત સલાહ અનુસરો.",
    "મારા ઓપરેશન પહેલાં મારે ક્યારથી ખાવું અને પીવું બંધ કરવું?",
    "ઓપરેશન પહેલાં મારી નિયમિત દવાઓમાંથી કઈ લેવી અથવા બદલવી જોઈએ?",
    "મારે ક્યાં જવાનું છે અને કેટલા વાગ્યે પહોંચવાનું છે?",
    "હોસ્પિટલમાં દાખલ થવા માટે મારે ક્યાં જવું અને ક્યારે પહોંચવું?",
    "શું હોસ્પિટલ જવા માટે મારે વાહનની વ્યવસ્થા કરવી પડશે કે પછી દર્દી પરિવહન સેવા માટે હું પાત્ર છું કે નહીં તે પૂછવું જોઈએ?",
    "ઓપરેશન પછી મને ઘરે લઈ જવા અથવા મારી સાથે રહેવા માટે કોઈની જરૂર પડશે?",
    "હોસ્પિટલમાંથી રજા મળતી વખતે મને કઈ મદદની જરૂર પડી શકે અને તે વિશે કોની સાથે વાત કરવી?",
    "ઘરે પાછા ફર્યા પછી કોઈ ચિંતા હોય તો મારે કોનો સંપર્ક કરવો?"
  ],
  "it": [
    "Domande sulla mia preparazione",
    "Seleziona le domande di cui vorresti parlare con l’équipe del tuo ospedale.",
    "Seleziona questa domanda",
    "Salva le domande selezionate in Le mie cure",
    "Stampa le domande selezionate",
    "Già salvata in Le mie cure",
    "Le domande selezionate sono state salvate in Le mie cure su questo dispositivo.",
    "Seleziona una o più domande da salvare o stampare.",
    "Domande che desidero fare",
    "Queste sono le domande sulla preparazione che hai selezionato. Puoi salvarle in Le mie cure o stamparle per portarle alla visita.",
    "Apri Le mie cure",
    "La stampa non invia le tue domande all’ospedale.",
    "Queste domande non sostituiscono le istruzioni del tuo ospedale. Per i medicinali, il digiuno e l’organizzazione delle dimissioni, segui le indicazioni personalizzate fornite dall’équipe ospedaliera.",
    "Quando devo smettere di mangiare e bere prima dell’intervento?",
    "Quali dei medicinali che prendo abitualmente devo assumere o modificare prima dell’intervento?",
    "Dove devo andare e a che ora devo arrivare?",
    "Dove devo presentarmi e a che ora per il ricovero?",
    "Devo organizzare il trasporto verso l’ospedale o chiedere se ho diritto al trasporto per i pazienti?",
    "Avrò bisogno di qualcuno che mi accompagni a casa o rimanga con me dopo l’intervento?",
    "Di quale aiuto potrei aver bisogno quando lascio l’ospedale e con chi dovrei parlarne?",
    "Chi devo contattare se ho delle preoccupazioni dopo essere tornato a casa?"
  ],
  "pa": [
    "ਮੇਰੀ ਤਿਆਰੀ ਬਾਰੇ ਸਵਾਲ",
    "ਜਿਨ੍ਹਾਂ ਗੱਲਾਂ ਬਾਰੇ ਤੁਸੀਂ ਹਸਪਤਾਲ ਦੀ ਦੇਖਭਾਲ ਟੀਮ ਨਾਲ ਚਰਚਾ ਕਰਨਾ ਚਾਹੁੰਦੇ ਹੋ, ਉਹ ਚੁਣੋ।",
    "ਇਹ ਸਵਾਲ ਚੁਣੋ",
    "ਚੁਣੇ ਹੋਏ ਸਵਾਲ ‘ਮੇਰੀ ਦੇਖਭਾਲ’ ਵਿੱਚ ਸੰਭਾਲੋ",
    "ਚੁਣੇ ਹੋਏ ਸਵਾਲ ਪ੍ਰਿੰਟ ਕਰੋ",
    "ਪਹਿਲਾਂ ਹੀ ‘ਮੇਰੀ ਦੇਖਭਾਲ’ ਵਿੱਚ ਸੰਭਾਲਿਆ ਗਿਆ ਹੈ",
    "ਚੁਣੇ ਹੋਏ ਸਵਾਲ ਇਸ ਡਿਵਾਈਸ ਉੱਤੇ ‘ਮੇਰੀ ਦੇਖਭਾਲ’ ਵਿੱਚ ਸੰਭਾਲੇ ਗਏ ਹਨ।",
    "ਸੰਭਾਲਣ ਜਾਂ ਪ੍ਰਿੰਟ ਕਰਨ ਲਈ ਇੱਕ ਜਾਂ ਵੱਧ ਸਵਾਲ ਚੁਣੋ।",
    "ਉਹ ਸਵਾਲ ਜੋ ਮੈਂ ਪੁੱਛਣਾ ਚਾਹੁੰਦਾ/ਚਾਹੁੰਦੀ ਹਾਂ",
    "ਇਹ ਤਿਆਰੀ ਬਾਰੇ ਤੁਹਾਡੇ ਚੁਣੇ ਹੋਏ ਸਵਾਲ ਹਨ। ਤੁਸੀਂ ਇਨ੍ਹਾਂ ਨੂੰ ‘ਮੇਰੀ ਦੇਖਭਾਲ’ ਵਿੱਚ ਸੰਭਾਲ ਸਕਦੇ ਹੋ ਜਾਂ ਮੁਲਾਕਾਤ ਲਈ ਪ੍ਰਿੰਟ ਕਰ ਸਕਦੇ ਹੋ।",
    "‘ਮੇਰੀ ਦੇਖਭਾਲ’ ਖੋਲ੍ਹੋ",
    "ਸਵਾਲ ਪ੍ਰਿੰਟ ਕਰਨ ਨਾਲ ਉਹ ਹਸਪਤਾਲ ਨੂੰ ਨਹੀਂ ਭੇਜੇ ਜਾਂਦੇ।",
    "ਇਹ ਸਵਾਲ ਤੁਹਾਡੇ ਹਸਪਤਾਲ ਦੀਆਂ ਹਦਾਇਤਾਂ ਦਾ ਬਦਲ ਨਹੀਂ ਹਨ। ਦਵਾਈਆਂ, ਓਪਰੇਸ਼ਨ ਤੋਂ ਪਹਿਲਾਂ ਖਾਣਾ-ਪੀਣਾ ਬੰਦ ਕਰਨ ਅਤੇ ਛੁੱਟੀ ਦੀਆਂ ਵਿਵਸਥਾਵਾਂ ਲਈ ਆਪਣੀ ਹਸਪਤਾਲ ਦੇਖਭਾਲ ਟੀਮ ਦੀ ਨਿੱਜੀ ਸਲਾਹ ਦੀ ਪਾਲਣਾ ਕਰੋ।",
    "ਮੇਰੇ ਓਪਰੇਸ਼ਨ ਤੋਂ ਪਹਿਲਾਂ ਮੈਨੂੰ ਕਦੋਂ ਤੋਂ ਖਾਣਾ ਅਤੇ ਪੀਣਾ ਬੰਦ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ?",
    "ਓਪਰੇਸ਼ਨ ਤੋਂ ਪਹਿਲਾਂ ਮੈਂ ਆਪਣੀਆਂ ਰੋਜ਼ਾਨਾ ਦੀਆਂ ਕਿਹੜੀਆਂ ਦਵਾਈਆਂ ਲਵਾਂ ਜਾਂ ਬਦਲਾਂ?",
    "ਮੈਨੂੰ ਕਿੱਥੇ ਜਾਣਾ ਹੈ ਅਤੇ ਕਿੰਨੇ ਵਜੇ ਪਹੁੰਚਣਾ ਹੈ?",
    "ਹਸਪਤਾਲ ਵਿੱਚ ਦਾਖ਼ਲੇ ਲਈ ਮੈਨੂੰ ਕਿੱਥੇ ਜਾਣਾ ਅਤੇ ਕਦੋਂ ਪਹੁੰਚਣਾ ਹੈ?",
    "ਕੀ ਮੈਨੂੰ ਹਸਪਤਾਲ ਜਾਣ ਲਈ ਸਵਾਰੀ ਦਾ ਪ੍ਰਬੰਧ ਕਰਨਾ ਪਵੇਗਾ, ਜਾਂ ਇਹ ਪੁੱਛਣਾ ਚਾਹੀਦਾ ਹੈ ਕਿ ਕੀ ਮੈਂ ਮਰੀਜ਼ਾਂ ਲਈ ਆਵਾਜਾਈ ਸੇਵਾ ਦਾ ਹੱਕਦਾਰ ਹਾਂ?",
    "ਕੀ ਓਪਰੇਸ਼ਨ ਤੋਂ ਬਾਅਦ ਮੈਨੂੰ ਘਰ ਲਿਜਾਣ ਜਾਂ ਮੇਰੇ ਨਾਲ ਰਹਿਣ ਲਈ ਕਿਸੇ ਦੀ ਲੋੜ ਪਵੇਗੀ?",
    "ਹਸਪਤਾਲ ਤੋਂ ਛੁੱਟੀ ਮਿਲਣ ਵੇਲੇ ਮੈਨੂੰ ਕਿਸ ਮਦਦ ਦੀ ਲੋੜ ਹੋ ਸਕਦੀ ਹੈ ਅਤੇ ਇਸ ਬਾਰੇ ਮੈਂ ਕਿਸ ਨਾਲ ਗੱਲ ਕਰਾਂ?",
    "ਘਰ ਵਾਪਸ ਜਾਣ ਤੋਂ ਬਾਅਦ ਕੋਈ ਚਿੰਤਾ ਹੋਵੇ ਤਾਂ ਮੈਨੂੰ ਕਿਸ ਨਾਲ ਸੰਪਰਕ ਕਰਨਾ ਚਾਹੀਦਾ ਹੈ?"
  ]
};
